var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.submission.canEdit || _vm.fromDashboard
        ? _c(
            "v-layout",
            {
              attrs: {
                row: "",
                wrap: "",
                "justify-space-around": "",
                "text-xs-center": ""
              }
            },
            [
              _c("v-flex", { attrs: { xs4: "" } }, [
                _c(
                  "div",
                  { on: { click: _vm.editForm } },
                  [_c("v-icon", [_vm._v("\n          mdi-pencil\n        ")])],
                  1
                )
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs4: "" } }, [
                _c(
                  "div",
                  { on: { click: _vm.copyForm } },
                  [
                    _c("v-icon", [
                      _vm._v("\n          mdi-content-copy\n        ")
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs4: "" } }, [
                _c(
                  "div",
                  { on: { click: _vm.deleteForm } },
                  [_c("v-icon", [_vm._v("\n          mdi-delete\n        ")])],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoading ? _c("div", [_c("loading-component")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-233906e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233906e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/action-icons/action-icons.vue
// module id = null
// module chunks = 